<!-- MODAL seleccionarCheque -->
<div mdbModal #seleccionarCheque="mdb-modal" class="modal fade" id="basicExample" tabindex="-1" role="dialog"
  aria-labelledby="myModalLabel" aria-hidden="true" [config]="{ backdrop: true, ignoreBackdropClick: true }">
  <div class="modal-dialog modal-lg" role="document">
    <form [formGroup]='formData' novalidate (ngSubmit)="buscar(1)">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title w-100 text-left" id="myModalLabel">
            Seleccionar Cheque
          </h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close"
            (click)="seleccionarCheque.hide()">
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div class="modal-body">
          <div class="row">
            <div class="col">
              <div class="md-form">
                <input value="" type="text" id="numpago" class="form-control" placeholder="Numero de Cheque" required
                  #numpago formControlName="nroCheque" onlyNumbers />
                <label for="numpago">Número de Cheque</label>
              </div>
            </div>

            <div class="col" style="max-width: 200px">
              <div class="md-form mb-0">
                <mdb-date-picker [inline]="true" name="fechaDesde" [placeholder]="'Desde'" formControlName="fechaDesde"
                  required></mdb-date-picker>
                <div
                  *ngIf="formData.get('fechaDesde').invalid && (formData.get('fechaDesde').dirty || formData.get('fechaDesde').touched)">
                  <mdb-error *ngIf="formData.get('fechaDesde').hasError('required')">Ingrese fecha desde
                  </mdb-error>
                </div>
              </div>
            </div>
            <div class="col" style="max-width: 200px">
              <div class="md-form mb-0">
                <mdb-date-picker [inline]="true" name="fechaHasta" [placeholder]="'Hasta'" formControlName="fechaHasta"
                  required></mdb-date-picker>
                <div
                  *ngIf="formData.get('fechaHasta').invalid && (formData.get('fechaHasta').dirty || formData.get('fechaHasta').touched)">
                  <mdb-error *ngIf="formData.get('fechaHasta').hasError('required')">Ingrese fecha hasta
                  </mdb-error>
                </div>
              </div>
            </div>

            <div class="col" style="width: 50px;">
              <button mdbBtn type="submit" class="btn-cuadrado" color="secondary" mdbWavesEffect>
                <mdb-icon fas icon="search"></mdb-icon>
              </button>
            </div>
          </div>

          <div class="row" *ngIf="busquedaIniciada && listaCheques.length === 0">
            <div class="col">
              <a mdbBtn color="info" class="waves-light" mdbWavesEffect>
                No existen registros para el filtro seleccionado</a>
            </div>
          </div>

          <table class="table table-striped table-hover table-sm align-middle"
            *ngIf="busquedaIniciada && listaCheques && listaCheques.length > 0">
            <thead class="grey lighten-2">
              <tr>
                <th scope="col">Nro. Cheque</th>
                <th scope="col">Banco</th>
                <th scope="col">Fecha</th>
                <th scope="col">Montos</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let cheque of listaCheques">
                <td>{{cheque.numero_doc}}</td>
                <td>{{cheque.banco_nombre_origen}}</td>
                <td>{{cheque.fecha_ingreso | fecha}}</td>
                <td class="text-right">$ {{cheque.monto | numerico}}</td>
                <td>
                  <button mdbBtn type="button" color="indigo" mdbWavesEffect class="btn" size="sm"
                    (click)="onSeleccionarCheque(cheque)">
                    Seleccionar
                  </button>
                </td>
              </tr>
            </tbody>
            <app-pagination [context]="paginationContext" (onPageChange)="onPageChange($event)">
            </app-pagination>
          </table>
        </div>
      </div>
    </form>
  </div>
</div>
